import { render, staticRenderFns } from "./CustomerListHeader.vue?vue&type=template&id=b5a503f0"
import script from "./CustomerListHeader.vue?vue&type=script&lang=js"
export * from "./CustomerListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports